var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2"},[_c('h5',[_vm._v(_vm._s(_vm._f("titleCase")(_vm.title)))]),_c('div',{staticClass:"p-2 description"},[_vm._v(_vm._s(_vm.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }